'use client';

import React from 'react';
import { twMerge } from 'tailwind-merge';

interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  variant?: 'fullWidth' | 'inset' | 'middle';
  className?: string;
  component?: React.ElementType;
  light?: boolean;
}

export const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  variant = 'fullWidth',
  className = '',
  component: Component = 'hr',
  light = false,
  ...other
}) => {
  // Base classes
  const baseClasses = light ? 'border-gray-100' : 'border-gray-200';

  // Orientation classes
  const orientationClasses = {
    horizontal: 'w-full border-t',
    vertical: 'h-auto border-l',
  }[orientation];

  // Variant classes
  const variantClasses = {
    fullWidth: '',
    inset: orientation === 'horizontal' ? 'ml-16' : 'mt-16',
    middle: orientation === 'horizontal' ? 'mx-4' : 'my-4',
  }[variant];

  // Combine all classes
  const dividerClasses = twMerge(baseClasses, orientationClasses, variantClasses, className);

  return <Component className={dividerClasses} {...other} />;
};

export default Divider;
